import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpRequestMethods,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { EndpointKeys, IDP_APPS } from '../constants/urls.constants';
import { GeoLocationResponse } from '../models/core-apis/geo-location.interfaces';
import { SBW_TIMEOUT } from '../constants/common.constants';

@Injectable({
  providedIn: 'root'
})
export class GeoLocationService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private logging: LoggingService
  ) {}

  getGeoLocation(): Observable<GeoLocationResponse> {
    return new ApiBuilder<string, GeoLocationResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.BOOK_WIDGET)
      .endpointKey(EndpointKeys.GEO_LOCATION_URL)
      .method(HttpRequestMethods.GET)
      .timeOut(SBW_TIMEOUT.COMMON)
      .errorHandler(this._handleError.bind(this))
      .create();
  }

  private _handleError(error: HttpErrorResponse): Observable<never> {
    this.logging.log(error.message);
    return throwError(error);
  }
}
